import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {InvoiceStatus} from '@gatewee/types/invoice';

@Pipe({
  name: 'invoiceStatus',
  standalone: false,
})
export class InvoiceStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: InvoiceStatus | string): string {
    return (
      this.translate.instant(`enums.invoiceStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
